export const itinerary = {
    name: '',
    account: '',
    client: '',
    patrolPoints: [],
    status: 'ACTIVE',
}
